import { useState } from "react";
import { ListChecks, UserCheck } from "lucide-react";
import { AdminEnrolmentsPage } from "./AdminEnrolmentsPage";
import { AdminMembersPage } from "./AdminMembersPage";

/**
 * Unified Members management page — merges the old Enrolments and Members tabs.
 *   • Allow-list tab: manage the enrolment allow-list. Sample CSV download and CSV
 *     upload panel live INSIDE this tab (context-specific to the allow-list flow).
 *   • Signed-in tab:  the list of users who have completed OTP login at least once.
 */
export function AdminMembersUnifiedPage() {
  const [tab, setTab] = useState("allow-list");
  return (
    <div className="flex flex-col gap-6" data-testid="admin-members-unified-page">
      <div>
        <p className="text-xs uppercase tracking-widest text-gold">Members</p>
        <h1 className="mt-1 text-3xl font-semibold text-text">Members & Enrolments</h1>
        <p className="mt-2 max-w-2xl text-sm text-muted">
          Manage the allow-list of who can log in via OTP, then track anyone who has
          actually signed in on the Signed-in tab.
        </p>
      </div>
      <div className="flex gap-2 border-b border-border">
        <TabButton
          active={tab === "allow-list"}
          onClick={() => setTab("allow-list")}
          icon={ListChecks}
          label="Allow-list"
          testId="tab-allow-list"
        />
        <TabButton
          active={tab === "signed-in"}
          onClick={() => setTab("signed-in")}
          icon={UserCheck}
          label="Signed-in members"
          testId="tab-signed-in"
        />
      </div>
      <div className="pt-2">
        {tab === "allow-list" ? <AdminEnrolmentsPage /> : <AdminMembersPage />}
      </div>
    </div>
  );
}

function TabButton({ active, onClick, icon: Icon, label, testId }) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testId}
      className={`inline-flex items-center gap-2 border-b-2 px-4 py-2.5 text-sm font-medium transition-colors ${
        active ? "border-gold text-gold" : "border-transparent text-muted hover:text-text"
      }`}
    >
      <Icon className="h-4 w-4" />
      {label}
    </button>
  );
}

export default AdminMembersUnifiedPage;
